export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openAlaCarteGrid({commit}) {
        commit('setAlaCarteGridOpen');
    },
    closeAlaCarteGrid({commit}) {
        commit('setAlaCarteGridClose');
    }
}
